import React from "react";

type SecondaryButtonProps = {
  children: React.ReactNode;

  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;

  className?: string;

  id?: string;
  name?: string;
  ariaLabel?: string;
};

function cn(...classes: Array<string | undefined | false>) {
  return classes.filter(Boolean).join(" ");
}

export default function SecondaryButton({
  children,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  className,
  id,
  name,
  ariaLabel,
}: SecondaryButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      id={id}
      name={name}
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
      className={cn(
        "flex items-center justify-center gap-2",
        "rounded-[8px]",
        "bg-[#131620]",
        "border border-[#99A1AA]",
        "shadow-[0_2px_4px_rgba(35,39,43,0.3)]",
        !isDisabled && "hover:brightness-110 active:brightness-95",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent",
        isDisabled && "opacity-60 cursor-not-allowed",
        className
      )}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
}

function Spinner() {
  return (
    <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="3"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
